module.exports = __webpack_public_path__ + "static/241202_9M_2024_Investor_Presentation_Final_v2-194b66d0a0b6651b9dd5f429e92d1f3a.pdf";